export interface CartData {
    id: string;
    subTotal: number;
    grandTotal?: number;
    step: number;
    shipping?: number;
    salesTax?: number;
    csz?: CSZ,
    coupon: string;
}

export interface DataLayerItemBase {
    brand: string;
    category: string;
    id: string | number;
    name: string;
    price: number | string;
    variant: string;
}

export interface DataLayerEcommerce {
    currencyCode?: string;
    impressions?: Array<DataLayerImpressionItem>;
    detail?: DataLayerEcommerceDetails;
    checkout?: DataLayerEcommerceTxObject;
    purchase?: DataLayerEcommerceTxObject;
    add?: { product: DataLayerTxItem | Array<DataLayerTxItem> };
    remove?: { product: DataLayerTxItem | Array<DataLayerTxItem> };
}

export interface DataLayerActionField {
    list?: any;
    id?: string | number;
    step?: string | number;
    revenue?: number;
    tax?: number;
    shipping?: number;
    coupon?: string;
}

export interface DataLayerEcommerceDetails {
    actionField: DataLayerActionField;
    products?: Array<DataLayerImpressionItem>;
}

export interface DataLayerEcommerceTxObject {
    actionField: DataLayerActionField;
    products: Array<DataLayerTxItem>;
    shipping?: string | number;
    subtotal?: string | number;
}

export interface DataLayerEvent {
    event: string;
    eventLabel: string;
}

export interface DataLayerModel extends DataLayerEvent {
    ecommerce: DataLayerEcommerce;    
    dimension1?: string | number; // Customer ID 
    dimension2?: string | number; // City
    dimension3?: string | number; // State
    dimension4?: string | number; // Zip
}

export interface CSZ {
    City: string;
    State: string;
    Zip: string;
}

export class DataLayerItem implements DataLayerItemBase {
    brand: string;
    category: string;
    id: string | number;
    name: string;
    price: number | string;
    variant: string;
}

export class DataLayerImpressionItem extends DataLayerItem {
    position: number;
}

export class DataLayerTxItem extends DataLayerImpressionItem {
    quantity: number;
}

export class SearchResultsEvent implements DataLayerEvent {
    event: string;
    eventLabel: string;
    dimension5: number;
    dimension6: string;
    dimension7: string;
}